export const onlyStringsRegex = /^[a-zA-ZáéíóúÁÉÍÓÚÀñÑ ]+$/g;
export const usernameRegex = /^[.a-zA-ZáéíóúÁÉÍÓÚÀñÑ_0-9]+$/;
export const isInteger = /^[0-9]+$/;
export const isIntegerGreaterThanZero = /^[1-9][0-9]*$/;
export const passwordRegex = /^(?=.*\d).{8,}$/;
export const emailRegex = /^[-A-Za-z0-9_.+%]+@[-A-Za-z0-9_.%]+\.[A-Za-z]+$/;
